// ─────────────────────────────────────────────────────────────
// AETHERIS DESIGN TOKENS — "Dark Mythral Chrome" (v2.0)
// ─────────────────────────────────────────────────────────────

export const colors = {
  // Backgrounds - Liquid Obsidian Layering
  bgPrimary: '#050508',        // Deepest space, absolute void
  bgCard: '#111119',           // Milled dark steel / heavy graphite container
  bgCardHover: '#181826',      // Energized chrome container on hover
  bgOverlay: 'rgba(5, 5, 8, 0.93)',     // High-opacity immersion overlay
  bgOverlayLight: 'rgba(5, 5, 8, 0.4)', // Smooth cinematic fade asset

  // Accents - High-Voltage Cybernetics
  accent: '#a336ff',           // Electric Violet / Core Neon Purple
  accentGlow: 'rgba(163, 54, 255, 0.35)', // Structural glow mesh
  accentAdmin: '#ff8c00',      // Overclocked Alert Orange (Admin UI)
  accentAdminGlow: 'rgba(255, 140, 0, 0.25)',

  // Borders - Brushed Metal Definition
  borderDefault: '#222230',    // Milled metallic panel seam
  borderSubtle: '#161622',     // Low-profile interior division
  borderGlow: '#cc88ff',       // Incandescent border edge for focus/active states

  // Typography Hierarchy
  textPrimary: '#ffffff',      // Pure stark white
  textSecondary: '#d1d1e0',    // Ice-chrome tinted gray
  textMuted: '#8a8a9e',        // Weathered titanium gray
  textFaint: '#525266',        // Dim cyber-grid text
  textVeryFaint: '#333344',    // Sub-structural matrix labels

  // Status Matrices
  error: '#ff4466',            // Plasma red
  errorGlow: 'rgba(255, 68, 102, 0.2)',
  success: '#00ff88',          // Kinetic green
  successGlow: 'rgba(0, 255, 136, 0.2)',
};

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  xxl: '24px',
  section: '48px',
};

export const radius = {
  xs: '3px',
  sm: '6px',
  md: '10px',
  lg: '16px',
  pill: '9999px',
  circle: '50%',
};

export const fontSizes = {
  xs: '11px',
  sm: '12px',
  base: '13px',
  md: '14px',
  lg: '16px',
  xl: '20px',
  xxl: '28px',
};

export const fontFamily =
  'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, monospace';

// Structural Pre-milled Fragments for Quick Component Injections
export const presets = {
  primaryButton: {
    background: `linear-gradient(135deg, ${colors.accent} 0%, #791fd9 100%)`,
    border: `1px solid ${colors.borderGlow}`,
    borderRadius: radius.sm,
    color: colors.textPrimary,
    fontWeight: '600',
    letterSpacing: '0.5px',
    cursor: 'pointer',
    boxShadow: `0 0 12px ${colors.accentGlow}`,
    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  outlineButton: {
    background: 'rgba(163, 54, 255, 0.03)',
    border: `1px solid ${colors.accent}`,
    borderRadius: radius.sm,
    color: colors.textPrimary,
    fontWeight: '600',
    letterSpacing: '0.5px',
    cursor: 'pointer',
    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  card: {
    background: colors.bgCard,
    border: `1px solid ${colors.borderDefault}`,
    borderRadius: radius.md,
    overflow: 'hidden',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  chromeGlass: {
    background: 'rgba(17, 17, 25, 0.75)',
    backdropFilter: 'blur(16px)',
    WebkitBackdropFilter: 'blur(16px)',
    border: `1px solid ${colors.borderDefault}`,
  }
};
